import { useMutation } from "react-query"
import api from "../../client"

const deleteData = async (uuid: string | undefined) => {
    const { data } = await api.delete(
        `/order-templates/${uuid}`,
    )
    return data
}

export const useOrderTemplateDelete = (uuid: string | undefined) => {
    return useMutation(() => {
        return deleteData(uuid)
    })
}
